<template>

    <div class="layout__container">

        <div class="layout__margin-25-0">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Sales Insight</el-breadcrumb-item>
                <el-breadcrumb-item><span class="text__colour-teal">New Customer Revenue</span></el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <h3 class="text__align-center text__colour-teal">New Customer Revenue</h3>

        <div class="layout__position-center">
            <div class="layout__position-left layout__width-100">
                <NewCustomerRevenueSearch v-bind:sales="sales"></NewCustomerRevenueSearch>
            </div>

            <div class="insights-table layout__width-100 layout__position-left">
                <div class="el-table__scroll-wrapper">
                    <div class="el-table__scroll-div">
                    </div>
                </div>
                <el-table class="el-table__09vh layout__height-1240px layout__scrolling__right" :data="sales" show-summary :summary-method="getSummaries" style="width: 100%;" @sort-change="handleSortOrderChange" 
                v-loading.fullscreen.lock="loading" element-loading-text="Loading..." element-loading-background="rgba(79, 147, 168, 0.2)" empty-text="No data has been returned">
                    <el-table-column prop="orderMonth" label="Month" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" width="100px" :formatter="getMonthName">
                    </el-table-column>
                    <el-table-column prop="orderYear" label="Year" class-name="layout__width-50px el-table-column__no-pointer" sortable="custom" width="50px">
                    </el-table-column>
                    <el-table-column prop="new" label="New" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" min-width="50px" :formatter="getAmount">
                    </el-table-column>
                    <el-table-column prop="newsales" label="New First Order Sales Value" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" width="120px" :formatter="getCurrencyAmount">
                    </el-table-column>

                    <el-table-column v-for="column in columns" 
                                    :key="column.label"
                                    :prop="column.prop"
                                    :label="column.label"
                                    :formatter="getCurrencyAmount"
                                    :min-width="column.minWidth"
                                    sortable="custom">
                    </el-table-column>

                    <el-table-column prop="totalsales" label="Total New Customer Value" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" width="120px" :formatter="getCurrencyAmount">
                    </el-table-column>
                    <el-table-column class-name="layout__width-10 el-table-column__no-pointer" width="100px">
                        <template slot-scope="scope">
                            <el-button class="button-teal button__download" size="mini" :loading="loadings[scope.$index]" v-on:click="csv(scope.$index, scope.row)">Download
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>

</template>

<script>

    import moment from 'moment';
    import Axios from 'axios';
    import NewCustomerRevenueSearch from '@/components/insights/NewCustomerRevenueSearch';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {sortJsonArrayHelper} from '@/mixins/sort-json-array.js';

    export default {
        name: "sales",
        mixins: [axios, csvDownloadHelper, dataFormatter, sortJsonArrayHelper],
        components: {
            NewCustomerRevenueSearch
        },
        props: {
            view: ''
        },
        data() {
            return {
                sales: [],
                columns: [],
                loading: false,
                loadings: {},
                serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv'
            }
        },
        created() {
            this.isUserAuthorised();
            this.initLoaders();
        },
        mounted() {
            var bw = document.getElementsByClassName("el-table__body-wrapper");
            bw[0].addEventListener('scroll', this.handleScroll1);
            var sw = document.getElementsByClassName("el-table__scroll-wrapper");
            sw[0].addEventListener('scroll', this.handleScroll2);
        },
        updated() {
            var h = document.getElementsByClassName("el-table__header");
            var sd = document.getElementsByClassName("el-table__scroll-div");
            sd[0].style.width = h[0].style.width;

            var bw = document.getElementsByClassName("el-table__body-wrapper");
            if (bw[0].scrollWidth > bw[0].clientWidth) {
                sd[0].style.display = "block";
            } else {
                sd[0].style.display = "none";
            }
        },
        methods: {
            initLoaders: function () {
                let self = this;
                this.sales.forEach(function (v, i) {
                    this.$set(self.loadings, i, false);
                });
            },
            handleScroll1(e) {
                var bw = document.getElementsByClassName("el-table__body-wrapper");
                bw[1].scrollLeft = bw[0].scrollLeft;
                var sw = document.getElementsByClassName("el-table__scroll-wrapper");
                sw[0].scrollLeft = bw[0].scrollLeft;
            },
            handleScroll2(e) {
                var sw = document.getElementsByClassName("el-table__scroll-wrapper");
                var bw = document.getElementsByClassName("el-table__body-wrapper");
                bw[0].scrollLeft = sw[0].scrollLeft;
            },
            getMonthName(row, column) {
                let monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
                return monthNames[row.orderMonth - 1];
            },
            getCurrencyAmount(row, column, cellValue) {
                if (typeof cellValue === 'undefined' || cellValue === null) {
                    return '£0'
                } else {
                    return '£' + this.returnWithCommas(parseFloat(cellValue).toFixed(2).toString());
                }
            },
            getAmount(row, column, cellValue) {
                if (typeof cellValue === 'undefined' || cellValue === null) {
                    return '0'
                } else {
                    return this.returnWithCommas(cellValue.toString());
                }
            },
            handleSortOrderChange(sortProps) {
                console.log('prop: ' + sortProps.prop);
                console.log('order: ' + sortProps.order);

                this.sortJsonArray(this.sales, sortProps.prop, sortProps.order.slice(0, 3));
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                
                columns.forEach((column, index) => {
                    var noTotalCols = ["Month", "Year"];
                    if (noTotalCols.indexOf(column.label) >= 0) {
                        sums[index] = '';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        if (column.label == 'New') {
                            sums[index] = this.returnWithCommas(values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0).toFixed(0).toString());
                        } else {
                            sums[index] = '£' + this.returnWithCommas(values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0).toFixed(2).toString());
                        }
                    } else {
                        sums[index] = '';
                    }
                });

                return sums;
            },
            csv(index, row) {
                var endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetNewCustomerRevenueDetails?year=' + row.orderYear + '&month=' + row.orderMonth;

                console.log(endpoint)

                this.$set(this.loadings, index, true);

                Axios.get(endpoint, this.returnHeaderUsingToken())
                .then(response => {
                    var orders = response.data.customerRevenueDetails;

                    var monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"],
                        noColReqd = ["orderYear", "orderMonth", "ref", "customer", "address", "territory", "clientContact", "clientTelNo", "clientEmail", "newsales", "totalsales"];

                    const fields = [
                        {label: 'Month', value: (row, field) => monthNames[row.orderMonth - 1]},
                        {label: 'Year', value: 'orderYear'},
                        {label: 'Ref', value: 'ref'},
                        {label: 'Customer', value: 'customer'},
                        {label: 'Address', value: 'address'},
                        {label: 'Territory', value: 'territory'},
                        {label: 'Client Contact', value: 'clientContact'},
                        {label: 'Client Tel No', value: 'clientTelNo'},
                        {label: 'Client Email', value: 'clientEmail'},
                        {label: 'New First Order Sales Value', value: 'newsales'}
                    ];

                    Object.keys(orders[0]).forEach(key => {
                        var columnName = key.toString();

                        if (noColReqd.indexOf(columnName) < 0) {
                            fields.push({"label":columnName, "value":columnName});
                        }
                    });

                    fields.push({"label":"Total New Customer Value", "value":"totalsales"});

                    this.downloadCsv(this.exportDate, fields, orders)

                    this.$nextTick(() => { // Loading should be closed asynchronously
                        this.$set(this.loadings, index, false);
                    });
                })
                .catch(error => {
                    if (error.response) {
                        this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                    }

                    this.$nextTick(() => { // Loading should be closed asynchronously
                        this.$set(this.loadings, index, false);
                    });
                })
            }
        }
    };
</script>